import app from "flarum/forum/app";
import RoundPage from "../RoundPage";
import Placeholder from "flarum/common/components/Placeholder";

export default class SCPRoundPage extends RoundPage {
  oncreate(vnode: any) {
    super.oncreate(vnode);

    app.setTitle(app.translator.trans("rhodes-island.forum.rounds.scp_title") as string);
    app.setTitleCount(0);
  }

  content() {
    return <Placeholder text={app.translator.trans("rhodes-island.forum.rounds.scp_not_available")}/>;
  }
}
